import { usePageContext } from 'vike-react/usePageContext';
import { brand, navLinks, navCta } from '@/content/shared';
import styles from './Nav.module.css';

export default function Nav() {
  const ctx = usePageContext();
  const path = ctx.urlPathname;

  return (
    <header className={styles.nav}>
      <a className={styles.brand} href="/">
        <img src={brand.logo} alt={brand.name} width={32} height={32} decoding="async" />
        <span className={styles.brandName}>{brand.name}</span>
      </a>

      <nav className={styles.links} aria-label="Primary">
        {navLinks.map((l) => {
          const active = path === l.href || path.startsWith(l.href + '/');
          return (
            <a
              key={l.href}
              href={l.href}
              className={active ? `${styles.linkItem} ${styles.active}` : styles.linkItem}
            >
              {l.label}
            </a>
          );
        })}
      </nav>

      <a className={styles.cta} href={navCta.href}>
        {navCta.label}
        <svg className={styles.arrow} viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.6">
          <path d="M3 8h10M9 4l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </a>
    </header>
  );
}
